import UserModulePermission from '@/types/user/userModulePermission'
import { BaseService } from './../../base'
export class UserModulePermissionService extends BaseService<UserModulePermission>() {
    static get entity (): string {
        return 'user_module_permission'
    }
    static get responseName (): string {
        return 'user_module_permission'
    }
}